import { gql } from "@apollo/client";

export const GET_PROMO_TYPES_LOOKUP = gql`
  query PromoTypesLookup {
    promoTypesLookup {
      count
      items {
        promoTypeId
        promoTypeName
        promoTypeCode
        promoTypeKey
      }
    }
  }
`;
